import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import Support from '../self-serve';
import Claims from '../self-serve/claims';
import ClaimsSingle from '../self-serve/claims-single';
import NewEnquiry from '../self-serve/enquiry';
import NewEnquiryOrderSearch from '../self-serve/enquiry-order-search';
import SupportTickets from '../self-serve/support-tickets';
import SupportTicketsSingle from '../self-serve/support-tickets-single';
import Surcharges from '../surcharges/surcharges';
import Cancellations from '../self-serve/cancellations';
import CancellationsSingle from '../self-serve/cancellations-single';
import CancellationsSuccess from '../self-serve/cancellations-success';
import AccountConcerns from '~/routes/smartsend/account-concerns';
import { SettingsCache } from '~/lib/consts/settings-cache';

export const childrenOfSupport = [
  {
    path: RoutingConstants.Support,
    element: <Support />
  },
  {
    path: RoutingConstants.Cancellations,
    children: [
      { path: '', element: <Cancellations /> },
      { path: 'success/:orderid', element: <CancellationsSuccess /> },
      { path: 'request/:orderid', element: <CancellationsSingle /> }
    ]
  },
  {
    path: RoutingConstants.Claims,
    children: [
      { path: '', element: <Claims /> },
      { path: ':id', element: <ClaimsSingle /> }
    ]
  },
  {
    path: RoutingConstants.SupportTickets,
    children: [
      { path: '', element: <SupportTickets /> },
      { path: RoutingConstants.SupportTickets_Raise, element: <NewEnquiryOrderSearch /> },
      { path: RoutingConstants.SupportTickets_Raise + '/:orderid', element: <NewEnquiry /> },
      { path: ':id', element: <SupportTicketsSingle /> }
    ]
  },
  {
    path: RoutingConstants.Surcharges,
    element: <Surcharges />
  },
  {
    path: RoutingConstants.AccountConcerns,
    element: <AccountConcerns />
  }
];

export const routesOfSupport = childrenOfSupport.map((r) => r.path);

export const sanitisedRoutesOfSupport = () =>
  routesOfSupport.filter((x) => {
    switch (x) {
      case RoutingConstants.Claims:
        return SettingsCache.settings.Features.includes('Claims');

      case RoutingConstants.SupportTickets:
        return SettingsCache.settings.Features.includes('Support');

      case RoutingConstants.Surcharges:
        return SettingsCache.settings.Features.includes('Surcharges');

      case RoutingConstants.Cancellations:
      case RoutingConstants.SupportTickets_Raise:
      case RoutingConstants.AccountConcerns:
        return false;

      default:
        return true;
    }
  });
